const sleep = time => new Promise(resolve => setTimeout(resolve, time));

// modified from https://github.com/kentcdodds/react-suspense/blob/master/src/fetch-pokemon.js
function fetchCharacter(name, delay = 2500) {
  const endTime = Date.now() + delay;
  const characterQuery = `
    query ($name: String) {
      Person(name: $name) {
        id
        name
        homeworld {
          name
        }
        films {
          title,
          episodeId
        }
      }
    }
  `;

  return window
    .fetch("https://swapi.graph.cool/", {
      method: "POST",
      headers: {
        "content-type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify({
        query: characterQuery,
        variables: { name: name.toLowerCase() }
      })
    })
    .then(response => response.json())
    .then(async response => {
      await sleep(endTime - Date.now());
      return response;
    })
    .then(response => {
      const character = response.data.Person;
      if (character) {
        return character;
      } else {
        return Promise.reject(new Error(`No Person with the name "${name}"`));
      }
    });
}

export default fetchCharacter;
